var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("gift-pack-detail", { attrs: { "is-create": false } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }